import {
  Image,
  StyleSheet,
  Text,
  View,
  SafeAreaView,
  TouchableOpacity,
  ScrollView,
  FlatList,
  Dimensions,
  TouchableWithoutFeedback,
} from "react-native";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AppImages from "../../Constants/AppImages";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
//import Appstyles from "../../Constants/AppStyles";
const { height, width } = Dimensions.get("screen");

const ConfigDrawer = ({ navigation }) => {
  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.sandal }}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: AppColors.white,
          height: 58,
          justifyContent: "space-between",
          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 1 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
          marginBottom: 20,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TouchableOpacity
            style={{ height: 30, width: 30, justifyContent: "center" }}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15 }}
            />
          </TouchableOpacity>

          <Text
            style={{
              color: AppColors.brown1,

              fontSize: 16,

              fontFamily: AppFonts.OverpassSemiBold,
            }}
          >
            Configuration checker
          </Text>
        </View>

        <View
          style={{
            flexDirection: "row",

            alignItems: "center",
          }}
        >
          <Image
            source={AppImages.VechicleNoti}
            style={{ width: 20, height: 20 }}
            resizeMode="contain"
          />

          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={{ width: 16, height: 20, marginLeft: 20 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={{
          backgroundColor: AppColors.white,
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
        }}
      >
        <View style={Appstyles.singlecard}>
          <View style={Appstyles.cardwidthview}>
            <Text style={Appstyles.cardwidthtext}>Description</Text>
          </View>
          <Text
            style={{
              padding: 20,
              color: AppColors.brown,
              fontSize: 14,
              fontFamily: AppFonts.OverpassMedium,
            }}
          >
            It is a long established fact that a reader will be distracted by
            the readable content of a page when looking at its layout. The point
            of using Lorem Ipsum is that it has a more-or-less normal
            distribution of letters, as opposed to using 'Content here, content
            here', making it look like readable English. Many desktop publishing
            packages and web page editors now use Lorem Ipsum as their default
            model text, and a search for 'lorem ipsum' will uncover many web
            sites still in their infancy. Various versions have evolved over the
            years, sometimes by accident, sometimes on purpose (injected humour
            and the like).
          </Text>
        </View>

        <View style={Appstyles.singlecard}>
          <View style={Appstyles.cardwidthview}>
            <Text style={Appstyles.cardwidthtext}>Conclusion</Text>
          </View>
          <Text
            style={{
              padding: 20,
              color: AppColors.brown,
              fontSize: 14,
              fontFamily: AppFonts.OverpassMedium,
            }}
          >
            It is a long established fact that a reader will be distracted by
            the readable content of a page when looking at its layout. The point
            of using Lorem Ipsum is that it has a more-or-less normal
            distribution of letters, as opposed to using 'Content here, content
            here', making it look like readable English. Many desktop publishing
            packages and web page editors
          </Text>
        </View>
        <View style={[Appstyles.cardwidthview, { margin: 20 }]}>
          <Text style={Appstyles.cardwidthtext}>Summary</Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginHorizontal: 20,
          }}
        >
          <View
            style={{
              borderColor: AppColors.sandal,
              borderWidth: 1,
              borderRadius: 10,
              flexDirection: "row",
              paddingHorizontal: 20,
              height: 40,
              width: "28%",
              backgroundColor: AppColors.lightgreen,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text
              style={{
                color: AppColors.brown1,
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
              }}
            >
              Passed
            </Text>
            <Text
              style={{
                color: AppColors.brown1,
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
              }}
            >
              05
            </Text>
          </View>
          <View
            style={{
              borderColor: AppColors.sandal,
              borderWidth: 1,
              borderRadius: 10,
              flexDirection: "row",
              paddingHorizontal: 20,
              height: 40,
              width: "28%",
              backgroundColor: "#FF00000D",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text
              style={{
                color: AppColors.brown1,
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
              }}
            >
              Failed
            </Text>
            <Text
              style={{
                color: AppColors.brown1,
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
              }}
            >
              02
            </Text>
          </View>
          <View
            style={{
              borderColor: AppColors.sandal,
              borderWidth: 1,
              borderRadius: 10,
              flexDirection: "row",
              paddingHorizontal: 20,
              height: 40,
              width: "28%",
              backgroundColor: "#F6A3000D",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text
              style={{
                color: AppColors.brown1,
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
              }}
            >
              Warning
            </Text>
            <Text
              style={{
                color: AppColors.brown1,
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
              }}
            >
              01
            </Text>
          </View>
        </View>
        <View style={Appstyles.greencard}>
          <View style={{ width: "60%" }}>
            <Text style={Appstyles.greentext}>Details</Text>
            <Text style={Appstyles.greentextone}>Vehicle Type</Text>
            <Text style={Appstyles.greentext}>Memo</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
          <View style={{ width: "40%" }}>
            <Text style={Appstyles.greentext}>Result</Text>
            <Text style={Appstyles.greentextone}>Passed</Text>
            <Text style={Appstyles.greentext}>Required Action</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
        </View>
        <View style={Appstyles.greencard}>
          <View style={{ width: "60%" }}>
            <Text style={Appstyles.greentext}>Details</Text>
            <Text style={Appstyles.greentextone}>Vehicle </Text>
            <Text style={Appstyles.greentext}>Memo</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
          <View style={{ width: "40%" }}>
            <Text style={Appstyles.greentext}>Result</Text>
            <Text style={Appstyles.greentextone}>Passed</Text>
            <Text style={Appstyles.greentext}>Required Action</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
        </View>
        <View style={Appstyles.greencard}>
          <View style={{ width: "60%" }}>
            <Text style={Appstyles.greentext}>Details</Text>
            <Text style={Appstyles.greentextone}>Drivers</Text>
            <Text style={Appstyles.greentext}>Memo</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
          <View style={{ width: "40%" }}>
            <Text style={Appstyles.greentext}>Result</Text>
            <Text style={Appstyles.greentextone}>Passed</Text>
            <Text style={Appstyles.greentext}>Required Action</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
        </View>
        <View style={Appstyles.greencard}>
          <View style={{ width: "60%" }}>
            <Text style={Appstyles.greentext}>Details</Text>
            <Text style={Appstyles.greentextone}>Bus Assistant</Text>
            <Text style={Appstyles.greentext}>Memo</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
          <View style={{ width: "40%" }}>
            <Text style={Appstyles.greentext}>Result</Text>
            <Text style={Appstyles.greentextone}>Passed</Text>
            <Text style={Appstyles.greentext}>Required Action</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
        </View>

        <View style={Appstyles.greencard}>
          <View style={{ width: "60%" }}>
            <Text style={Appstyles.greentext}>Details</Text>
            <Text style={Appstyles.greentextone}>Routes</Text>
            <Text style={Appstyles.greentext}>Memo</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
          <View style={{ width: "40%" }}>
            <Text style={Appstyles.greentext}>Result</Text>
            <Text style={Appstyles.greentextone}>Passed</Text>
            <Text style={Appstyles.greentext}>Required Action</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
        </View>
        <View
          style={{
            marginHorizontal: 20,
            marginTop: 20,
            borderRadius: 10,
            borderWidth: 0.5,
            borderColor: AppColors.sandal,
            backgroundColor: AppColors.lightyellow,
            paddingTop: 20,
            paddingBottom: 10,
          }}
        >
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentext}>Details</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentext}>Result</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentextone}>Vehicle Type</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentextone}>Passed</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentext}>Memo</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentext}>Required Action</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={[Appstyles.greentextone, { width: "90%" }]}>
                Below Drivers Are Not Assigned Yet
              </Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={[Appstyles.greentextone, { width: "90%" }]}>
                Go to Vehicle Assignment
              </Text>
            </View>
          </View>
          <View style={{ width: "60%", paddingLeft: 20 }}>
            <Text style={Appstyles.drivers}>1. Ajinkya</Text>
            <Text style={Appstyles.drivers}>2. Bhagyesh</Text>
            <Text style={Appstyles.drivers}>3. Pawan</Text>
            <Text style={Appstyles.drivers}>4. Avinash</Text>
          </View>
        </View>
        <View style={Appstyles.greencard}>
          <View style={{ width: "60%" }}>
            <Text style={Appstyles.greentext}>Details</Text>
            <Text style={Appstyles.greentextone}>
              Vehicle Notification Setting
            </Text>
            <Text style={Appstyles.greentext}>Memo</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
          <View style={{ width: "40%" }}>
            <Text style={Appstyles.greentext}>Result</Text>
            <Text style={Appstyles.greentextone}>Passed</Text>
            <Text style={Appstyles.greentext}>Required Action</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
        </View>

        <View
          style={{
            marginHorizontal: 20,
            marginTop: 20,
            borderRadius: 10,
            borderWidth: 0.5,
            borderColor: AppColors.sandal,
            backgroundColor: AppColors.lightRed,
            paddingTop: 20,
            paddingBottom: 10,
          }}
        >
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentext}>Details</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentext}>Result</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentextone}>Pickup Points</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentextone}>Failed</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentext}>Memo</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentext}>Required Action</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={[Appstyles.greentextone, { width: "90%" }]}>
                Below Drivers Are Not Assigned Yet
              </Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={[Appstyles.greentextone, { width: "90%" }]}>
                Go to Pickup points
              </Text>
            </View>
          </View>
          <View style={{ width: "60%", paddingLeft: 20 }}>
            <Text style={Appstyles.drivers}>1. Ajinkya</Text>
            <Text style={Appstyles.drivers}>2. Bhagyesh</Text>
            <Text style={Appstyles.drivers}>3. Pawan</Text>
            <Text style={Appstyles.drivers}>4. Avinash</Text>
          </View>
        </View>

        <View style={Appstyles.redcardone}>
          <View style={{ width: "60%" }}>
            <Text style={Appstyles.greentext}>Details</Text>
            <Text style={Appstyles.greentextone}>General Settings</Text>
            <Text style={Appstyles.greentext}>Memo</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              Transportation Type os not Set
            </Text>
          </View>
          <View style={{ width: "40%" }}>
            <Text style={Appstyles.greentext}>Result</Text>
            <Text style={Appstyles.greentextone}>Failed</Text>
            <Text style={Appstyles.greentext}>Required Action</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              Go to Pickup points
            </Text>
          </View>
        </View>
        <View style={Appstyles.greencard}>
          <View style={{ width: "60%" }}>
            <Text style={Appstyles.greentext}>Details</Text>
            <Text style={Appstyles.greentextone}>Notification Settings</Text>
            <Text style={Appstyles.greentext}>Memo</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
          <View style={{ width: "40%" }}>
            <Text style={Appstyles.greentext}>Result</Text>
            <Text style={Appstyles.greentextone}>Passed</Text>
            <Text style={Appstyles.greentext}>Required Action</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
        </View>
        <View style={Appstyles.greencard}>
          <View style={{ width: "60%" }}>
            <Text style={Appstyles.greentext}>Details</Text>
            <Text style={Appstyles.greentextone}>Trips</Text>
            <Text style={Appstyles.greentext}>Memo</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
          <View style={{ width: "40%" }}>
            <Text style={Appstyles.greentext}>Result</Text>
            <Text style={Appstyles.greentextone}>Passed</Text>
            <Text style={Appstyles.greentext}>Required Action</Text>
            <Text
              style={{
                fontSize: 14,
                fontFamily: AppFonts.OverpassRegular,
                color: AppColors.brown,
              }}
            >
              _
            </Text>
          </View>
        </View>

        <View
          style={{
            marginHorizontal: 20,
            marginTop: 20,
            borderRadius: 10,
            borderWidth: 0.5,
            borderColor: AppColors.sandal,
            backgroundColor: AppColors.lightRed,
            paddingTop: 20,
            paddingBottom: 10,
          }}
        >
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentext}>Details</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentext}>Result</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentextone}>
                Trips Based On Vehicles
              </Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentextone}>Failed</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentext}>Memo</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentext}>Required Action</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={[Appstyles.greentextone, { width: "90%" }]}>
                Below vehicles are not assigned with any trips.
              </Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={[Appstyles.greentextone, { width: "90%" }]}>
                Go to Trip
              </Text>
            </View>
          </View>
        </View>

        <View
          style={{
            marginHorizontal: 20,
            marginVertical: 20,
            borderRadius: 10,
            borderWidth: 0.5,
            borderColor: AppColors.sandal,
            backgroundColor: AppColors.lightRed,
            paddingTop: 20,
            paddingBottom: 10,
          }}
        >
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentext}>Details</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentext}>Result</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentextone}>Trip Duration</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentextone}>Failed</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={Appstyles.greentext}>Memo</Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={Appstyles.greentext}>Required Action</Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: "60%", paddingLeft: 20 }}>
              <Text style={[Appstyles.greentextone, { width: "90%" }]}>
                Below trips do not have trip duration.
              </Text>
            </View>
            <View style={{ width: "40%" }}>
              <Text style={[Appstyles.greentextone, { width: "90%" }]}>
                Go to Trip
              </Text>
            </View>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default ConfigDrawer;

const Appstyles = StyleSheet.create({
  singlecard: {
    marginHorizontal: 20,
    marginTop: 20,
    borderRadius: 10,
    borderWidth: 0.5,
    borderColor: AppColors.sandal,
  },
  cardwidthview: {
    backgroundColor: AppColors.sandal,
    borderRadius: 10,

    borderWidth: 1,
    borderColor: AppColors.sandal,
  },
  cardwidthtext: {
    fontSize: 16,
    color: AppColors.brown,
    fontFamily: AppFonts.OverpassSemiBold,
    padding: 15,
  },
  greencard: {
    borderColor: AppColors.sandal,
    borderWidth: 1,
    borderRadius: 10,
    flexDirection: "row",
    paddingHorizontal: 20,
    marginHorizontal: 20,
    marginTop: 20,
    paddingVertical: 20,
    backgroundColor: AppColors.lightgreen,
    alignItems: "center",
    justifyContent: "space-between",
  },
  greentext: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
    marginBottom: 10,
  },
  greentextone: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
    marginBottom: 10,
  },
  redcard: {
    borderColor: AppColors.sandal,
    borderWidth: 1,
    borderRadius: 10,
    flexDirection: "row",
    paddingHorizontal: 20,
    marginHorizontal: 20,
    marginTop: 20,
    paddingVertical: 20,
    backgroundColor: AppColors.lightRed,
    alignItems: "center",
    justifyContent: "space-between",
  },
  redcardone: {
    borderColor: AppColors.sandal,
    borderWidth: 1,
    borderRadius: 10,
    flexDirection: "row",
    paddingHorizontal: 20,
    marginHorizontal: 20,
    marginTop: 20,
    paddingVertical: 20,
    backgroundColor: "#FF00000D",
    alignItems: "center",
    justifyContent: "space-between",
  },
  redcardtwo: {
    borderColor: AppColors.sandal,
    borderWidth: 1,
    borderRadius: 10,

    paddingHorizontal: 20,
    marginHorizontal: 20,
    marginTop: 20,
    paddingVertical: 20,
    backgroundColor: AppColors.lightRed,
    alignItems: "center",
    justifyContent: "space-between",
  },
  rightName: {
    flex: 1,
    flexDirection: "row",
    alignItems: "flex-start",
    paddingHorizontal: 20,
    paddingTop: 10,
  },
  email: {
    color: AppColors.brown1,
    fontSize: 12,
    fontFamily: AppFonts.OverpassSemiBold,
  },
  answr: {
    width: "60%",
    color: AppColors.brown,
    fontSize: 12,
    fontFamily: AppFonts.OverpassBold,
    marginLeft: 10,
  },
  drivers: {
    fontSize: 14,
    marginLeft: 30,
    color: AppColors.brown,
    marginBottom: 10,
    width: "90%",
    fontFamily: AppFonts.OverpassMedium,
  },
});
